<template>
	<v-container fluid>
		<v-row>
			<v-col cols="11">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
			</v-col>
			<v-col cols="1">
				<export-excel :items="items" :headers="headers" :fileName="excelFileName">
				</export-excel>
			</v-col>
			<v-col cols="12">
				<v-data-table :height="dataTableFixedHeight - 100" fixed-header :headers="headers" :loading="loading" :items="items" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td>
								<div class="info--text" @click="edit(row.item)" style="cursor:pointer">
									{{ row.item.code }}
								</div>
							</td>
							<td>
								<div>{{ row.item.memberModel.fullName }}</div>
								<div>
									<small class="">کد ملی: </small>
									<small class="grey--text">{{ row.item.memberModel.nationalCode }}</small>
								</div>
							</td>
							<td>{{ row.item.loanModel.title }}</td>
							<td class="text-center">
								{{ row.item.amount.toString().toPriceFormat() }}
							</td>
							<td class="text-center ltr">
								{{ `${row.item.sponsoreDueDate_Persian.date}` }}
							</td>
							<td class="text-center ltr">
								{{ row.item.sponsoreAmount.toString().toPriceFormat() }}
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
		<div class="d-flex" style="position: absolute;bottom: 0;left: 0;
    left: 0;
		right: 0;
    font-size: 22px;
    background-color: rebeccapurple;
    color: #fff;
		justify-content: end;
    flex-wrap: wrap;">
			<div class="text-center px-3 py-3">
				مجموع: {{ sum.toString().toPriceFormat() }} تومان
			</div>
		</div>

		<v-dialog v-model="dialog" scrollable persistent max-width="1100px">
			<modify-request ref="modifyRequest" v-if="dialog" :data="selectedRequest" @callbck="callbck" @close="dialog = false" />
		</v-dialog>

	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import { emptyId } from '@/util/emptyId'

	export default {
		name: 'DueDatedRequestsBySponsore',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-picker': VuePersianDatetimePicker,
			'modify-request': () => import('@/views/admin/ModifyLoanRequest.vue'),
		},
		data() {
			return {
				selectedTransaction: null,
				dialog: false,
				selectedRequest: {},
				errorMessages: '',
				search: '',
				loading: false,
				sum: 0,
				sumByDelays: 0,
				headers: [
					{
						text: 'شماره درخواست',
						align: 'start',
						sortable: true,
						value: 'code',
						width: 50
					}, {
						text: 'نام مشتری',
						align: 'start',
						sortable: true,
						value: 'memberModel.fullName',
						width: 150
					},
					{
						text: 'کد ملی',
						align: 'start d-none',
						sortable: true,
						value: 'memberModel.nationalCode',
					},
					{
						text: 'وام',
						align: 'start',
						sortable: true,
						value: 'loanModel.title',
					},
					{
						text: 'مبلغ وام',
						align: 'center',
						sortable: true,
						value: 'amount',
					},
					{
						text: 'تاریخ سررسید تسویه توسط اسپانسر',
						align: 'center',
						sortable: true,
						value: 'sponsoreDueDate_Persian',
					},
					{
						text: 'قابل واریز اسپانسر',
						align: 'center',
						sortable: true,
						value: 'sponsoreAmount',
					},
				],
				items: [],
			}
		},
		computed: {
			excelFileName() {
				let name = 'لیست سررسید های طرف حساب ها'
				// if (this.dateRange.start)
				// 	name += ' از ' + this.dateRange.start.toString().split('T')[0]
				// if (this.dateRange.end)
				// 	name += ' تا ' + this.dateRange.end.toString().split('T')[0]
				name += '.xls'
				return name
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/UserLoanRequest/GetDueDatedRequestsBySponsore', {})
					.then(
						response => {
							this.items = response
							if (response.length)
								this.sum = response.map(x => x.amount).reduce((prev, next) => {
									return prev + next
								})
							else
								this.sum = 0
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			edit(item) {
				this.selectedRequest = item
				this.dialog = true
			},
			callbck(result) {
				this.loadData()
			},
		},
	}
</script>
<style></style>
